document.addEventListener("DOMContentLoaded", function () {
	const parent = document.querySelector(
		".newsletter-form"
	);
	const checkbox = parent.querySelector(
		"#privacy_policy"
	);
	const subscribeButton =
		parent.querySelector("#Subscribe");

	checkbox.addEventListener("change", function () {
		if (this.checked) {
			subscribeButton.removeAttribute("disabled");
		} else {
			subscribeButton.setAttribute(
				"disabled",
				"disabled"
			);
		}
	});

	function handleScroll() {
		const footerSection = document.querySelector(
			".shopify-section-group-footer-group"
		);
		const whatsappButton = document.querySelector(
			".footer__whatsapp_button"
		);

		if (!whatsappButton) return;

		const footerVisible =
			footerSection &&
			isElementInViewport(footerSection);

		if (footerVisible) {
			whatsappButton.classList.add(
				"footer__whatsapp_button-sticky"
			);
			whatsappButton.classList.remove(
				"footer__whatsapp_button-fixed"
			);
		} else {
			whatsappButton.classList.add(
				"footer__whatsapp_button-fixed"
			);
			whatsappButton.classList.remove(
				"footer__whatsapp_button-sticky"
			);
		}
	}

	function isElementInViewport(el) {
		const rect = el.getBoundingClientRect();
		return (
			rect.top < window.innerHeight && rect.bottom > 0
		);
	}

	window.addEventListener("scroll", handleScroll);
	handleScroll(); // Initial check
});
